import { useState } from 'react'

import { CellContentSaleTypeWithPen } from 'app/components/common/cellContents/CellContentSaleTypeWithPen'
import { SaleType } from 'app/dataTypes/dishes/saleType'
import PlainButton from 'app/common/ui-next/plain-button'
import PlainLinkAsButton from 'app/common/ui-next/plain-link-as-button'
import { DishId } from 'app/common/types/id'

import { KbzhuModal } from './KbzhuModal'
import styles from './DishesTableSaleType.module.scss'

export const DishesTableSaleType = ({
  dishId,
  dishTitle,
  saleTypeId,
  saleTypesLoading,
  saleTypes,
  locked,
  submitSaleType,
  submitKbzhu,
  techCardLink,
  showKbzhuButton,
}: {
  dishId: DishId
  dishTitle: string
  saleTypeId: string
  saleTypesLoading: boolean
  saleTypes: Array<SaleType>
  locked?: boolean
  submitSaleType: (saleTypeId: string) => Promise<boolean>
  submitKbzhu: (props: {
    proteins: number
    fats: number
    carbohydrates: number
    caloric: number
    comment: string
  }) => Promise<boolean>
  techCardLink?: string
  showKbzhuButton?: boolean
}) => {
  const [showKbzhuModal, setShowKbzhuModal] = useState(false)

  return (
    <div className={styles.root}>
      <div className={styles.dropdownContainer}>
        <CellContentSaleTypeWithPen
          id={dishId}
          currentSaleTypeId={saleTypeId}
          pending={saleTypesLoading}
          saleTypes={saleTypes}
          locked={locked}
          onChangeSaleType={submitSaleType}
        />
      </div>
      {showKbzhuButton && !locked && (
        <PlainButton onClick={() => setShowKbzhuModal(true)}>{'КБЖУ'}</PlainButton>
      )}
      {techCardLink && !locked && (
        <PlainLinkAsButton to={techCardLink}>{'Тех. карта'}</PlainLinkAsButton>
      )}
      {showKbzhuModal && (
        <KbzhuModal
          dishTitle={dishTitle}
          onSubmit={submitKbzhu}
          onClose={() => setShowKbzhuModal(false)}
        />
      )}
    </div>
  )
}
